import React, { useState, useEffect, useRef } from "react";

import Button from "../../button/button_v2";
import Select from "../../select/select_v2";
import Input from "../../input/input_v2";
import api from "../../../services/api";
import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
import ModalYesNo from "../../modal/modalYesNo";
import Modal from "../../modal/modalGeneric";
import AddProdutor from '../../../pages/produtores/add';
import AddFazenda from '../../../pages/produtores/addlocal';

import { FormContainer } from "./styles";
import { Container } from "react-grid-system";
import { store } from "react-notifications-component";
import { isTotvs, isOmie } from "../../../services/globalFunctions";

// import Date from "datejs";

const Contracts = ({ onContractSaved, ...props }) => {
    const {
        estado,
        agronomo,
        crea,
        numeroArt,
        apelido,
        quantidadeReceita,
        receitaInicial,
        quantidadeContratos,
        numeroOrdem,
        dataValidade,
    } = props;

    const [produtorId, setProdutorId] = useState("");
    const [localAplicacaoId, setLocalAplicacaoId] = useState("");

    const [produtores, setProdutores] = useState([]);
    const [locaisAplicacao, setlocaisAplicacao] = useState([]);
    const [filial, setFilial] = useState('');
    const [valorContrato, setValorContrato] = useState("");
    const [dataInicial, setDataInicial] = useState("");
    const [dataFinal, setDataFinal] = useState("");
    const [newId, setNewId] = useState('');
    const [erroId, setErroId] = useState('');
    const [valReal, setValReal] = useState('');
    const [addModal, setAddModal] = useState(false);

    const [disabled, setDisabled] = useState(false);
    const [addModalShow, setAddModalShow] = useState(false);
    const [addModalFazenda, setAddModalFazenda] = useState(false);
    const [idProdutor, setIdProdutor] = useState('');

    const [loading, setLoading] = useState(false);
    const [erroProdutor, setErroProdutor] = useState(false)
    const [erroLocal, setErrolocalAplicacao] = useState(false)
    const [erroValor, setErroValContrato] = useState(false)
    const [erroDataI, setErroDataInicial] = useState(false)
    const [erroDataF, setErroDataFinal] = useState(false)

    const [showModalAddFazenda, setShowModalAddFazenda] = useState(false);

    const PRODUTOR_FAZENDA_STORAGE_KEY = '@agroreceita_produtor_fazenda';
    const savedProdutorFazendaRef = useRef(null);
    const didHydrateProdutorRef = useRef(false);
    const didHydrateFazendaRef = useRef(false);


    const updateIdProdutor = async () => {
            setAddModalShow(false);
            getProducers();
            getFilial();
    };

    const updateFazenda = async (e) => {
        setAddModalFazenda(false);
        getProducers();

    };

    const formatCpfCnpj = (value) => {
        if (!value) return "";

        const cleaned = value.replace(/\D/g, "");

        if (cleaned.length <= 11) {
            return cleaned.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4")
                .replace(/^(\d{3})(\d{3})(\d{3})$/, "$1.$2.$3")
                .replace(/^(\d{3})(\d{3})$/, "$1.$2")
                .replace(/^(\d{3})$/, "$1");
        } else {
            return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5")
                .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})$/, "$1.$2.$3/$4")
                .replace(/^(\d{2})(\d{3})(\d{3})$/, "$1.$2.$3")
                .replace(/^(\d{2})(\d{3})$/, "$1.$2")
                .replace(/^(\d{2})$/, "$1");
        }
    };

    const formatProducers = produtores => {
        produtores = produtores.map(produtor => {
            const format = {
                value: produtor.id || produtor.agro_producer_id,
                label: `${produtor.id_externo && !isOmie() ? produtor.id_externo + ': ' : ''}${produtor.nome || produtor.nome_produtor}` + (produtor.cpf_cnpj ? ` - CPF/CNPJ: ${formatCpfCnpj(produtor.cpf_cnpj)}` : ''),
                cpf_cnpj: produtor.cpf_cnpj
            };
            return format;
        });
        return produtores;
    };

    const formatFarms = farms => {
        farms = farms.map(farm => {
            const format = {
                value: farm.id,
                label: farm.nome
            };
            return format;
        });
        return farms;
    };

    const formatArtDisplay = (numero, apelido) => {
        const numeroTexto = numero ? String(numero) : '';
        const apelidoTexto = apelido ? String(apelido) : '';

        if (numeroTexto && apelidoTexto) {
            return `${numeroTexto} - ${apelidoTexto}`;
        }

        return numeroTexto;
    };

    const getArtDisplayValue = () => {
        const artLabel = props.art?.label ? String(props.art.label) : '';
        const artNumero = props.art?.numero_art || props.numeroArt || '';
        const artApelido = props.art?.apelido || props.apelido || '';

        if (artLabel && artApelido && !artLabel.includes(` - ${artApelido}`)) {
            return `${artLabel} - ${artApelido}`;
        }

        if (artLabel) {
            return artLabel;
        }

        return formatArtDisplay(artNumero, artApelido);
    };

    const getProducers = async () => {
        // const response = await api.get(`/filiais/${filial}/produtores`);
        try {
            const response = await api.get(`/produtores/estado/${props.estado.value || props.estado}`);
            let produtores = response.data.data;
            produtores = formatProducers(produtores);
            setProdutores(produtores);
        } catch (error) {
            const errorMessage = identifyErrorMenssage(
                error,
                "Erro ao buscar produtores."
            );
            
            store.addNotification({
                title: "Erro!",
                message: errorMessage,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            return;
        }
    };

    const getfarms = async () => {
        try {
            setLocalAplicacaoId('');

            const response = await api.get(`/fazendas/estado/${produtorId.value}/${props.estado.value || props.estado}`);
            let farms = response.data.data;
            farms = formatFarms(farms);
            setlocaisAplicacao(farms);
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error, "ERRO-556 Erro ao buscar fazendas - Tente novamente, se o erro persistir acione o suporte."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });

        }
    };

    const getFilial = async () => {
        try {
            // const response = await api.get(`/agronomos/${agronomo.value || agronomo}`);
            // setFilial(response.data.data.filial.id);
            // getProducers(response.data.data.filial.id);

            const payload ={
                    search: "",
                    estado: "SP"
            }

            const response = await api.post(`/agronomos/pesquisa?limit=30&offset=0`, payload);

            if (response) {
                getProducers();
            }

        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error, "ERRO-557 Erro ao buscar dados - Tente novamente, se o erro persistir acione o suporte."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            // return;
        }
    };

    // Checagem de duplicidade por CREA + número ART/TRT antes de criar
    const checkDuplicateArt = async (creaParam, numeroArtParam, estadoParam) => {
        try {
            const payload = { search: numeroArtParam, estado: estadoParam };
            const response = await api.post(`/art/pesquisa?limit=1&offset=0`, payload);
            let arts = [];
            if (response && response.data && response.data.data && response.data.data.arts) {
                arts = response.data.data.arts;
            } else if (response && response.data && response.data.data) {
                arts = response.data.data;
            }
            const targetCreaId = (creaParam && creaParam.value) || creaParam;

            const duplicate = arts.some(a =>
                (a && a.numero_art === numeroArtParam) &&
                (
                    (a.crea && a.crea.id === targetCreaId) ||
                    (a.crea_id === targetCreaId)
                )
            );

            return duplicate;
        } catch (e) {
            return false;
        }
    };

    const saveART = async () => {

        const payload = {
            estado: estado.value || estado,
            agronomoId: agronomo.value || agronomo,
            produtorId: produtorId.value,
            nome_produtor: produtorId.label,
            creaId: crea.value || crea,
            apelido: apelido || null,
            numero_art: numeroArt,
            receita_inicial: receitaInicial,
            quantidade_contratos: quantidadeContratos,
            numero_ordem: numeroOrdem,
            data_validade: dataValidade
        };

        // Checa duplicidade antes de criar a ART
        const estadoVal = estado.value || estado;
        const isDuplicate = await checkDuplicateArt(crea, numeroArt, estadoVal);
        if (isDuplicate) {
            setErroId('Esse número de ART/TRT já existe para o CREA selecionado.');
            store.addNotification({
                title: "Erro!",
                message: "Esse número de ART/TRT já existe para o CREA selecionado.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
            });
            return;
        }

        try {
            const response = await api.post(`/creas/${crea.value || crea}/arts`, payload);
            setNewId(response);

        } catch (error) {
            const apiErrorMessage = identifyErrorMenssage(
                error,
                "Erro ao cadastrar ART/TRT."
            );
            const responseErrors = error.response?.data?.errors;

            if (typeof responseErrors === 'string') {
                setErroId(apiErrorMessage);
    
                store.addNotification({
                    title: "Erro!",
                    message: apiErrorMessage,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } else {
                setErroId(apiErrorMessage);
    
                store.addNotification({
                    title: "Erro!",
                    message: apiErrorMessage,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });

                props.back();
            }


            // return;
        }
    };

    const saveContract = async e => {
        setLoading(true);

        if (erroId && newId === '') {
            setLoading(false);
            store.addNotification({
                title: "Erro!",
                message: `${erroId}`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } else {

            let id = '';

            if (props.isModal !== true) {
                id = newId.data.data.id;
            } else if (props.isModal === true && props.numeroArt && typeof props.numeroArt === 'number') {
                id = props.numeroArt
            } else {
                if (props.isModal === true && typeof props.numeroArt === 'string') {
                    if (props.artId && typeof props.artId === 'number') {
                        id = newId;
                    } else {
                        id = newId.data.data.id;
                    }
                } else {
                    if (props.artId) {
                        id = props.artId;
                    }
                }
            }
    
            let localId = localAplicacaoId.value;
    
            const payloadB = {
                agro_art_id: id,
                agro_farm_id: localId,
                nome_produtor: produtorId.label,
                valor_contrato: parseFloat(valorContrato),
                data_inicio: dataInicial,
                data_termino: dataFinal
            };
    
    
            try {
                const responseB = await api.post(`/contratos`, payloadB);
                setLoading(false);
                
                if (typeof onContractSaved === 'function') {
                    onContractSaved();
                }
                
                if (props.isModal === true) {
                    props.update();
                } else {
                    props.loc.history.push(`/contracts/${id}`);
                }
            } catch (err) {
                setLoading(false);
                const responseErrors = err.response?.data?.errors;
                const apiErrorMessage = identifyErrorMenssage(
                    err,
                    "Erro ao cadastrar contrato."
                );

                if (responseErrors === "Data de inicio deve ser igual ou menor que a data atual.") {
                    setErroDataInicial(true)
                }

                if (typeof responseErrors === 'string') {
                    store.addNotification({
                        title: "Erro!",
                        message: apiErrorMessage,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                } else {
                    const ERRO = responseErrors;
                    let msgErro = '';
    
                    if (ERRO?.invalid?.data_termino !== undefined) {
                        setErroDataFinal(true);
                        msgErro=ERRO.invalid.data_termino;
                    }
    
                    if (ERRO?.invalid?.data_inicio !== undefined) {
                        setErroDataInicial(true);
                        msgErro=ERRO.invalid.data_inicio;
    
                    }
    
                    if (ERRO && err.response?.data?.message) {
                        setErrolocalAplicacao(true);
                        store.addNotification({
                            title: "Erro!",
                            message: identifyErrorMenssage(
                                err,
                                msgErro || "Erro ao cadastrar contrato."
                            ),
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    } else {
                        try {
                            
                            if (ERRO.invalid) {
                                
                                if(ERRO.invalid.agro_art_id){
                                    store.addNotification({
                                        title: "Erro!",
                                        message: identifyErrorMenssage(
                                            err,
                                            msgErro || ERRO.invalid.agro_art_id
                                        ),
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                }else if (ERRO.invalid.data_inicio) {
            
                                    let inputWithErrors = document.querySelectorAll(".error");
            
                                    // for (let input of inputWithErrors) {
                                    //     input.classList.remove("error");
                                    // }
                                    for (let input of inputWithErrors) {
                                        // input.classList.remove("error");
                                        if (input === 'nome_produtor') {
                                            setErroProdutor(false);
                                        } else if (input === 'agro_farm_id') {
                                            setErrolocalAplicacao(false);
                                        } else if (input === 'valor_contrato') {
                                            setErroValContrato(false);
                            
                                        } else if (input === 'data_inicio') {
                                            setErroDataInicial(false);
                            
                                        } else if (input === 'data_termino') {
                                            setErroDataFinal(false);
                            
                                        }
                                    }
                
                                    const errors = err.response.data.errors.invalid;
                
                
                                    // for (let field in errors) {
                                    //     const input = document.getElementById(field);
                                    //     input.classList.add("error");
                                    // }
                                    for (let input of errors) {
                                        // input.classList.remove("error");
                                        if (input === 'nome_produtor') {
                                            setErroProdutor(true);
                                        } else if (input === 'agro_farm_id') {
                                            setErrolocalAplicacao(true);
                                        } else if (input === 'valor_contrato') {
                                            setErroValContrato(true);
                            
                                        } else if (input === 'data_inicio') {
                                            setErroDataInicial(true);
                            
                                        } else if (input === 'data_termino') {
                                            setErroDataFinal(true);
                                        }
                                    }
            
            
                                    store.addNotification({
                                        title: "Erro!",
                                        message: identifyErrorMenssage(
                                            err,
                                            msgErro || ERRO.invalid.data_inicio
                                        ),
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                } else if (ERRO.invalid.data_termino) {
                                    let inputWithErrors = document.querySelectorAll(".error");
            
                                    for (let input of inputWithErrors) {
                                        // input.classList.remove("error");
                                        if (input === 'nome_produtor') {
                                            setErroProdutor(false);
                                        } else if (input === 'agro_farm_id') {
                                            setErrolocalAplicacao(false);
                                        } else if (input === 'valor_contrato') {
                                            setErroValContrato(false);
                            
                                        } else if (input === 'data_inicio') {
                                            setErroDataInicial(false);
                            
                                        } else if (input === 'data_termino') {
                                            setErroDataFinal(false);
                            
                                        }
                                    }
                
                                    const errors = err.response.data.errors.invalid;
                
                
                                    // for (let field in errors) {
                                    //     const input = document.getElementById(field);
                                    //     input.classList.add("error");
                                    // }
                                    for (let input of errors) {
                                        // input.classList.remove("error");
                                        if (input === 'nome_produtor') {
                                            setErroProdutor(true);
                                        } else if (input === 'agro_farm_id') {
                                            setErrolocalAplicacao(true);
                                        } else if (input === 'valor_contrato') {
                                            setErroValContrato(true);
                            
                                        } else if (input === 'data_inicio') {
                                            setErroDataInicial(true);
                            
                                        } else if (input === 'data_termino') {
                                            setErroDataFinal(true);
                                        }
                                    }
            
                                    store.addNotification({
                                        title: "Erro!",
                                        message: identifyErrorMenssage(
                                            err,
                                            msgErro || ERRO.invalid.data_termino
                                        ),
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                }
                            } else {
            
                                let inputWithErrors = document.querySelectorAll(".error");
            
                                // for (let input of inputWithErrors) {
                                //     input.classList.remove("error");
                                // }
                                for (let input of inputWithErrors) {
                                    // input.classList.remove("error");
                                    if (input === 'nome_produtor') {
                                        setErroProdutor(false);
                                    } else if (input === 'agro_farm_id') {
                                        setErrolocalAplicacao(false);
                                    } else if (input === 'valor_contrato') {
                                        setErroValContrato(false);
                        
                                    } else if (input === 'data_inicio') {
                                        setErroDataInicial(false);
                        
                                    } else if (input === 'data_termino') {
                                        setErroDataFinal(false);
                        
                                    }
                                }
            
                                const errors = err.response.data.errors;
            
            
                                // for (let field in errors) {
                                //     const input = document.getElementById(field);
                                //     input.classList.add("error");
                                // }
            
                                for (let input of errors) {
                                    // input.classList.remove("error");
                                    if (input === 'nome_produtor') {
                                        setErroProdutor(true);
                                    } else if (input === 'agro_farm_id') {
                                        setErrolocalAplicacao(true);
                                    } else if (input === 'valor_contrato') {
                                        setErroValContrato(true);
                        
                                    } else if (input === 'data_inicio') {
                                        setErroDataInicial(true);
                        
                                    } else if (input === 'data_termino') {
                                        setErroDataFinal(true);
                                    }
                                }
            
                                
            
                                store.addNotification({
                                    title: "Erro!",
                                    message: "Verifique os campos em vermelho",
                                    type: "danger",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                            }
            
                        } catch (err) {
                            store.addNotification({
                                title: "Erro!",
                                message: identifyErrorMenssage(
                                    err,
                                    msgErro || apiErrorMessage
                                ),
                                type: "danger",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                        }
                    }

                }
    

            }
        }
    };


    const normalizeDateValue = (value) => {
        if (!value) return '';
        if (typeof value === 'string') return value;
        if (value?.target?.value) return value.target.value;
        return String(value);
    };

    const parseComparableDate = (value) => {
        const raw = normalizeDateValue(value);
        if (!raw) return null;

        const s = raw.includes('T') ? raw.slice(0, 10) : raw;

        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
            return new Date(`${s}T00:00:00`);
        }

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
            const [d, m, y] = s.split('/');
            return new Date(`${y}-${m}-${d}T00:00:00`);
        }

        return null;
    };

    const shouldValidateDatesWithReceita = Boolean(props.inicialDateReceita);

    const validateDataFinalRules = ({ dataInicioStr, dataTerminoStr }) => {
        const dataTerminoRaw = normalizeDateValue(dataTerminoStr);
        const dataInicioRaw = normalizeDateValue(dataInicioStr);

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        const termino = parseComparableDate(dataTerminoRaw);
        const inicio = parseComparableDate(dataInicioRaw);

        if (!dataTerminoRaw) {
            return { hasError: true, message: 'Preencha a data final.' };
        }

        if (termino && termino.getTime() < hoje.getTime()) {
            return { hasError: true, message: 'A data final não pode ser menor que a data de hoje.' };
        }

        if (dataInicioRaw && termino && inicio && termino.getTime() < inicio.getTime()) {
            return { hasError: true, message: 'A data final não pode ser menor que a data inicial.' };
        }

        return { hasError: false, message: '' };
    };

    const validateReceitaDentroDoContrato = ({ receitaDateStr, dataInicioStr, dataTerminoStr }) => {
        const receita = parseComparableDate(receitaDateStr);
        const inicio = parseComparableDate(dataInicioStr);
        const termino = parseComparableDate(dataTerminoStr);

        if (receita && inicio && receita.getTime() < inicio.getTime()) {
            store.addNotification({
                title: "Erro!",
                message: "A data da receita não pode ser anterior à data inicial do contrato.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 7000,
                    onScreen: true,
                },
            });
            setErroDataInicial(true)
        }

        if (receita && termino && receita.getTime() > termino.getTime()) {
            store.addNotification({
                title: "Erro!",
                message: "A data da receita não pode ser posterior à data final do contrato.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 7000,
                    onScreen: true,
                },
            });
            setErroDataFinal(true)
        }
    };

    const validateDataInicial = (value) => {
        const v = normalizeDateValue(value);
        if (v.length < 11) {
            setDataInicial(v);
        }
    };

    const validateDataFinal = (value) => {
        const v = normalizeDateValue(value);
        if (v.length < 11) {
            setDataFinal(v);
        }
    };

    const validateValorContrato = valorContrato => {
        setValorContrato(valorContrato);
    };

    const moeda = (valor) => {
        const raw = (valor ?? '').toString();
        const numeric = raw.replace(/\D/g, '');

        if (!numeric) {
            setValReal('');
            validateValorContrato('');
            return;
        }

        const numberValue = Number(numeric) / 100;
        const formatted = numberValue.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        setValReal(formatted);
        validateValorContrato(numberValue.toFixed(2));
    };

    const openModal = (e) => {
        // e.preventDefault();

        if (props.contratosUtilizados >= props.quantidadeContratos) {
            store.addNotification({
                title: "Erro!",
                message: "Limite de contratos atingido",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            return;
        }

        let inputWithErrors = document.querySelectorAll(".error");

        for (let input of inputWithErrors) {
            // input.classList.remove("error");
            if (input === 'nome_produtor') {
                setErroProdutor(false);
            } else if (input === 'agro_farm_id') {
                setErrolocalAplicacao(false);
            } else if (input === 'valor_contrato') {
                setErroValContrato(false);

            } else if (input === 'data_inicio') {
                setErroDataInicial(false);

            } else if (input === 'data_termino') {
                setErroDataFinal(false);

            }
        }

        if (shouldValidateDatesWithReceita) {
            const { hasError, message } = validateDataFinalRules({
                dataInicioStr: dataInicial,
                dataTerminoStr: dataFinal,
            });

            if (hasError) {
                setErroDataFinal(true);
                store.addNotification({
                    title: "Erro!",
                    message,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                return;
            }
        }

        if (!produtorId || !localAplicacaoId || !valReal || !dataInicial || !dataFinal) {
            store.addNotification({
                title: "Erro!",
                message: "Verifique os campos em vermelho",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }

        if (!produtorId) {
            setErroProdutor(true);
        } else {
            setErroProdutor(false);
        }

        if (!localAplicacaoId) {
            setErrolocalAplicacao(true);
        } else {
            setErrolocalAplicacao(false);
        }

        if (!valReal) {
            setErroValContrato(true);
        } else {
            setErroValContrato(false);
        }

        if (!dataInicial) {
            setErroDataInicial(true);
        } else {
            if (dataInicial.length > 10) {
                setErroDataInicial(true);
            } else {
                setErroDataInicial(false);
            }
        }

        if (!dataFinal) {
            setErroDataFinal(true);
        } else {
            if (dataFinal.length > 10) {
                setErroDataFinal(true);
            } else {
                setErroDataFinal(false);
            }
        }

        if (produtorId && localAplicacaoId && valReal && dataInicial && dataFinal) {
            if (props.isModal === true) {
                saveContract();
            } else {
                setAddModal(true);
            }
        }

    };

    const openModalProdutor = e => {
        setAddModalShow(true);
    };

    const updateResposta = async (resposta) => {
        if (resposta == 1) {
            setAddModal(false);
            saveContract();
        } else {
            setAddModal(false);

        }
    };

    const modalClose = e => {

        if (addModal == true) {
            setAddModal(true);

        }
        if (addModalShow == true) {
            setAddModalShow(false);
        }

        if (addModalFazenda == true) {
            setAddModalFazenda(false);
        }
    };

    const addNewFazenda = () => {
        setShowModalAddFazenda(true);
    }

    const updateFazendas = () => {
        setShowModalAddFazenda(false);
        getfarms();
    }

    useEffect(() => {
        if (erroLocal === true) {
            setErrolocalAplicacao(false);
        }
    },[localAplicacaoId])

    useEffect(() => {
        if (props.isModal != true) {
            window.scrollTo(0, 0);
        }
        try {
            const raw = localStorage.getItem(PRODUTOR_FAZENDA_STORAGE_KEY);
            if (raw) {
                const parsed = JSON.parse(raw);
                const savedProdutorId = parsed?.produtor?.id ?? parsed?.produtor?.value;
                const savedFazendaId =
                    parsed?.produtor?.fazenda?.id ??
                    parsed?.produtor?.fazenda?.value ??
                    parsed?.fazenda?.id ??
                    parsed?.fazenda?.value;

                if (savedProdutorId && savedFazendaId) {
                    savedProdutorFazendaRef.current = {
                        produtorId: savedProdutorId,
                        fazendaId: savedFazendaId,
                    };
                }
            }
        } catch (e) {
            savedProdutorFazendaRef.current = null;
        }
        getFilial();
    }, [])

    useEffect(() => {
        if (didHydrateProdutorRef.current) return;
        if (!Array.isArray(produtores) || produtores.length === 0) return;
        if (produtorId && produtorId.value) return;

        const saved = savedProdutorFazendaRef.current;
        if (!saved?.produtorId) return;

        const match = produtores.find(p => String(p.value) === String(saved.produtorId));
        if (match) {
            setProdutorId(match);
        }
        didHydrateProdutorRef.current = true;
    }, [produtores, produtorId])

    useEffect(() => {
        if (didHydrateFazendaRef.current) return;
        if (!Array.isArray(locaisAplicacao) || locaisAplicacao.length === 0) return;
        if (localAplicacaoId && localAplicacaoId.value) return;

        const saved = savedProdutorFazendaRef.current;
        if (!saved?.fazendaId) return;

        const match = locaisAplicacao.find(f => String(f.value) === String(saved.fazendaId));
        if (match) {
            setLocalAplicacaoId(match);
        }
        didHydrateFazendaRef.current = true;
    }, [locaisAplicacao, localAplicacaoId])

    useEffect(() => {
        
        if (produtorId) {
            getfarms();
        }
    }, [produtorId])

    useEffect(() => {
        if (dataInicial) return;
        const receitaDate = normalizeDateValue(props.inicialDateReceita);
        if (!receitaDate) return;
        setDataInicial(receitaDate);
        setErroDataInicial(false);
    }, [props.inicialDateReceita, dataInicial])

    useEffect(() => {
        if (props.isModal === true && props.numeroArt && typeof props.numeroArt === 'number') {

        } else {
            if (props.isModal === true && typeof props.numeroArt === 'string') {

                if (props.artId && typeof props.artId === 'number') {
                    setNewId(props.artId);
                } else {
                    saveART();
                }
            } else {
                saveART();
            }
        }
    }, []);


    return (
        <>
            <FormContainer isModal={props.isModal}>
                <Container>

                    {props.isModal === true ? (null) : (
                        <div className="steps">

                            <div className="btn-step">
                                <label>1</label>
                            </div>

                            <div className="btn-step">
                                <label>2</label>
                            </div>
                            <div className="btn-step-selected">
                                <label>3</label>
                            </div>
                        </div>
                    )}


                    <form 
                        // onSubmit={openModal}
                    >
                        {/* <div className="adicionar"> */}
                        
                        {props.art?.label || props.numeroArt ? (
                            <Input
                                name="art_trt"
                                className="text"
                                label="ART/TRT"
                                id="art_trt"
                                type='text'
                                // value={props.art?.label ? props.art.label : props.numeroArt}
                                value={getArtDisplayValue()}
                                disabled={true}
                                marginBottom="12px"
                            />
                        ):("")}

                        <Select
                            name="produtor"
                            className="select"
                            label="Produtor"
                            labelWithAsterisk={true}
                            id="nome_produtor"
                            value={produtorId.value || produtorId}
                            onChange={produtorId =>
                                produtorId ? setProdutorId(produtorId) : setProdutorId("")
                            }
                            options={produtores}
                            selectUniqueOption={true}
                            erro={erroProdutor}
                            disabled={false}
                            buttonAddNew={true}
                            onClickAddNew={() => openModalProdutor()}
                            isModal={props.isModal}
                            marginBottom="42px"
                            height="auto"
                            isTotvs={isTotvs()}
                        />
                            {/* <label className="add" onClick={openModalProdutor}>Adicionar novo</label>

                        </div> */}

                        <Select
                            name="localAplicacao"
                            className="select"
                            label="Local de Aplicação"
                            labelWithAsterisk={true}
                            id="agro_farm_id"
                            value={localAplicacaoId.value || localAplicacaoId}
                            onChange={localAplicacao =>
                                localAplicacao
                                    ? setLocalAplicacaoId(localAplicacao)
                                    : setLocalAplicacaoId("")
                            }
                            options={locaisAplicacao}
                            selectUniqueOption={true}
                            erro={erroLocal}
                            disabled={false}
                            buttonAddNew={produtorId.value || produtorId ? true : false}
                            onClickAddNew={() => addNewFazenda()}
                            marginBottom="42px"
                            height="auto"
                            isTotvs={isTotvs()}
                        />

                        <Input
                            name="valorContrato"
                            className="text"
                            label="Valor do Contrato (R$)"
                            labelWithAsterisk={true}
                            id="valor_contrato"
                            type='text'
                            inputMode="numeric"
                            value={valReal}
                            onChange={e => moeda(e)}
                            erro={erroValor}
                            marginBottom="12px"
                        />

                        <Input
                            name="dataInicial"
                            className="text"
                            label="Data Inicial"
                            labelWithAsterisk={true}
                            id="data_inicio"
                            mask="99/99/9999"
                            type="date"
                            value={dataInicial}
                            onChange={(value) => {
                                const nextDataInicial = normalizeDateValue(value);
                                validateDataInicial(nextDataInicial);
                                if (shouldValidateDatesWithReceita) {
                                    if (!nextDataInicial) {
                                        setErroDataInicial(true);
                                    } else {
                                        setErroDataInicial(false);
                                    }

                                    if (dataFinal) {
                                        const { hasError } = validateDataFinalRules({
                                            dataInicioStr: nextDataInicial,
                                            dataTerminoStr: dataFinal,
                                        });
                                        setErroDataFinal(hasError);
                                    }

                                    validateReceitaDentroDoContrato({
                                        receitaDateStr: props.inicialDateReceita,
                                        dataInicioStr: nextDataInicial,
                                        dataTerminoStr: dataFinal,
                                    });
                                }
                            }}
                            erro={erroDataI}
                            marginBottom="12px"
                        />

                        <Input
                            name="dataFinal"
                            className="text"
                            label="Data Final"
                            labelWithAsterisk={true}
                            id="data_termino"
                            mask="99/99/9999"
                            type="date"
                            value={dataFinal}
                            onChange={(value) => {
                                const nextDataFinal = normalizeDateValue(value);
                                validateDataFinal(nextDataFinal);
                                if (shouldValidateDatesWithReceita) {
                                    const { hasError } = validateDataFinalRules({
                                        dataInicioStr: dataInicial,
                                        dataTerminoStr: nextDataFinal,
                                    });
                                    setErroDataFinal(hasError);

                                    validateReceitaDentroDoContrato({
                                        receitaDateStr: props.inicialDateReceita,
                                        dataInicioStr: dataInicial,
                                        dataTerminoStr: nextDataFinal,
                                    });
                                }
                            }}
                            onBlur={() => {
                                if (!shouldValidateDatesWithReceita) return;

                                const { hasError } = validateDataFinalRules({
                                    dataInicioStr: dataInicial,
                                    dataTerminoStr: dataFinal,
                                });
                                setErroDataFinal(hasError);
                            }}
                            erro={erroDataF}
                            marginBottom="12px"
                        />

                        {/* <Button type="submit" >
                            Cadastrar
                        </Button> */}

                        <div className="button-finish" style={{ width: '100%', display: addModalShow === true ? 'none' : 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '15px', marginBottom: '0px' }}>
                            <Button 
                                width='100%'
                                height='50px'
                                value='SALVAR'
                                outline={false}
                                disabled={false}
                                // onClick={() => emitirReceita({stepOneParams, stepTwoParams, stepThreeParams})}
                                onClick={() => openModal()}
                                loading={loading}
                            />
                        </div>

                        <ModalYesNo
                            show={addModal}
                            onHide={modalClose}
                            resposta=''
                            update={(e) => updateResposta(e)}
                            title='Atenção!'
                            text='Você tem certeza que deseja salvar esta ART/TRT? Após confirmação os dados não poderão ser alterados ou removidos.'
                        ></ModalYesNo>

                        {/* <ModalAddProdutor
                            show={addModalShow}
                            onHide={modalClose}
                            update={updateIdProdutor}
                        /> */}

                        <Modal
                            show={addModalShow}
                            onHide={() => modalClose()}
                            size='lg'
                        >
                            <AddProdutor isModal={true} update={() => updateIdProdutor()}/>
                        </Modal>
                        
                        {/* {idProdutor > 0 ? (<>
                            <ModalAddFazenda
                                show={addModalFazenda}
                                produtorId={idProdutor}
                                onHide={modalClose}
                                update={updateFazenda}
                            />

                        </>) : null} */}

                        {showModalAddFazenda ? (
                            <Modal
                                size='lg'
                                show={showModalAddFazenda}
                                onHide={() => setShowModalAddFazenda(false)}
                            >
                                <AddFazenda 
                                    isModal={true} 
                                    update={() => updateFazendas()}
                                    match={{
                                        params: {
                                            id: produtorId.value || produtorId
                                        }
                                    }}
                                />
                            </Modal>
                        ) : (null)}
                    </form>
                </Container>
            </FormContainer>
        </>
    );
};
export default Contracts;
